<template>
    <b-row class="slide-body bc-color">
        <b-row align-h="center" class="pt-2 pb-2"> 
            <h1 style="color:#4e74e0"><strong>{{ $t('slide10.text1') }}</strong></h1>
        </b-row>
        <b-row align-h="center" class="pb-3">   
            <b-col cols="3"> 
            </b-col>
            <b-col cols="3"> 
                <div class="contenedor">  
                    <router-link :to="{name:'slide11',params:{lang:lang}}">              
                        <b-img align="bottom" src="@/images/slide10-rectangle.png" fluid></b-img>
                        <div class="texto-centrado"><h4 style="color:#ffffff"><strong>{{ $t('slide10.text2') }}</strong></h4></div>
                    </router-link>
                </div>                                       
            </b-col>
            <b-col cols="3">                     
                <div class="contenedor"> 
                    <router-link :to="{name:'slide12',params:{lang:lang}}">                
                        <b-img align="bottom" src="@/images/slide10-rectangle.png" fluid></b-img>
                        <div class="texto-centrado"><h4 style="color:#ffffff"><strong>{{ $t('slide10.text3') }}</strong></h4></div>
                    </router-link>
                </div>                                                                     
            </b-col> 
            <b-col cols="3"> 
            </b-col>            
        </b-row> 
        <b-row align-h="center" class="pb-2">   
            <b-col cols="3"> 
            </b-col>
            <b-col cols="3"> 
                <div class="contenedor">                
                    <router-link :to="{name:'slide13',params:{lang:lang}}"> 
                        <b-img align="bottom" src="@/images/slide10-rectangle.png" fluid></b-img>
                        <div class="texto-centrado"><h4 style="color:#ffffff"><strong>{{ $t('slide10.text4') }}</strong></h4></div>
                    </router-link>
                </div>                                       
            </b-col>
            <b-col cols="3">                     
                <div class="contenedor">                
                    <router-link :to="{name:'slide14',params:{lang:lang}}"> 
                        <b-img align="bottom" src="@/images/slide10-rectangle.png" fluid></b-img>
                        <div class="texto-centrado"><h4 style="color:#ffffff"><strong>{{ $t('slide10.text5') }}</strong></h4></div>
                    </router-link>
                </div>                                                                     
            </b-col> 
            <b-col cols="3"> 
            </b-col>            
        </b-row>            
    </b-row>
</template>

<script>

export default { 
    props:['lang'], 
    beforeCreate(){       
        this.$store.dispatch('updateVariable',{name: 'showSendAnswer',value: true});
    },
    created(){
        this.$i18n.locale=this.lang;
        this.$emit('changeColor', 'bc-color-white');  
    }  
}
</script>


<style scoped>

    .row{
        margin-left: 0px;
        margin-right: 0px;  
        width: 100%; 
    }

    .bc-color{
        background: #ffffff;
    }

    img {
        max-width: 100%;
        height: auto;
    }

    .contenedor{
        position: relative;
        display: inline-block;
        text-align: center;
    }

    .texto-centrado{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }   

</style>